export const demoData = {
  version: 1.0,
  title: "Qualtrics Demo",
  flows: [
    {
      id: 0,
      sections: [
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step0_Titlecard"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 1,
      sections: [
        {
          card: {
            transition: true,
            text: "Distribute notifications in Teams through the Qualtrics XM Actions platform",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Q"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          card: {
            transition: false,
            text: "With Qualtrics XM in Teams, employees can lead real-time resolutions for customers by viewing and acting on customer responses to web-based surveys.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image1a"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The Qualtics login portal is open in a full screen browser window. There are textboxes for a user name and password, a sign in CTA, and a forgot password link. There’s also a CTA to sign up if you don’t have an account.",
        },
        {
          card: {
            transition: false,
            text: "Log into the Qualtrics web app",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "14%",
              x: "45%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image1a"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the username text box.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "24.5%",
              x: "49.2%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image1a"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "QualtricsXM_Step1_Image1b",
              "QualtricsXM_Step1_Image1c",
              "QualtricsXM_Step1_Image1d",
            ],
          },
          screenReaderText:
            "The user types meganb@contoso.com into the “username” text box. A password is entered into the next text box and a purple pop-up points to the “sign in” button below the password text box.",
        },
        {
          card: {
            transition: false,
            text: "Select the Create new project button",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "17%",
              x: "91%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image2"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The view has changed to a Qualtrics dashboard for a folder titled “All projects”. The dashboard lists 4 surveys. A purple pop-up points to a button titled “Create new project” in the upper right-hand corner.",
        },
        {
          card: {
            transition: false,
            text: "Choose one of the customer research templates",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "42.4%",
              x: "22.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image3"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the “Create new project” button and the view has changed to a catalog view of surveys. There are 6 tabs across the top of the page – All, Core XM & Design XM, Customer XM, Employee XM, Product XM, Brand XM. The “All” tab is highlighted. Under the tabs there are 2 sections titled “Recent” and “Projects from Scratch”. Below the “Recents” section is a tile titled “Relationship NPS”. There is a purple pop-up pointing to this tile.",
        },
        {
          card: {
            transition: false,
            text: "Users can also create custom surveys through the Qualtrics web app as well as a wide range of ready-to-use templates.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "81%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image4"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, there are 4 tiles under the “Projects from Scratch” section – Survey, Engagement 360 and Lifecycle. There is a purple rectangle highlighting these 4 tiles.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "94.2%",
              x: "89%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image5"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, under the “Recent” section the tile “Relationship NPS” is outlined in blue indicating the user has clicked it. A drawer on the right side of the screen appears explaining the survey. A purple pop-up points to a “Get started” button at the bottom of the drawer.",
        },
        {
          card: {
            transition: false,
            text: "Provide a name for the project",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "18%",
              x: "3%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image6"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A new page titled “Relationship NPS” is open. There is purple pop-up pointing at the Name text box.",
        },
        {
          card: {
            transition: false,
            text: "Press the Create project button",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "94%",
              x: "93%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image7"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "“Contoso NPS” is entered into the name text box. In the bottom right corner of the screen there is a purple pop-up icon pointing to a “Create project” button.",
        },
        {
          card: {
            transition: false,
            text: "Customize the survey for your company",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "14%",
              x: "3.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image8a"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A new page titled “Company Details” is open. A purple pop-up points to a text box under a header that reads “Enter the industry your organization is in.”",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "63.5%",
              x: "12.71%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image8a"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "QualtricsXM_Step1_Image8a",
              "QualtricsXM_Step1_Image8b",
              "QualtricsXM_Step1_Image8c",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Technology” into the text box. In the same view the user has typed “Contoso” in a text box under a header that reads “Enter your company name as you would like it to appear in the survey.” Below this section there’s a header that reads “Enter 2-5 relationship drivers to measure”. There are 5 options to choose from – Product quality, Customer support, Brand reputation, Purchasing experience, Interaction(s) with en. “Interaction(s) with en” has a purple pop-up.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "59%",
              x: "12.71%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image9"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to “Purchasing experience”.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "77.9%",
              x: "2.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image10"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, below the “Enter 2-5 relationship drivers to measure” section there is a section titled, “Select the demographic questions you would like to include”. There are 5 check boxes to select from – Age, Education, Employment Status, Gender, Marital Status. A purple pop-up icon is pointed to “Age”.",
        },
        {
          card: {
            transition: false,
            text: "Press Finish",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95%",
              x: "61.8%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image11"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, there is now a check mark selecting “Age”. A purple pop-up points to a “Finish” CTA button in the lower right-hand corner.",
        },
        {
          card: {
            transition: false,
            text: "Navigate to the Actions tab",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "5.2%",
              x: "6.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image12"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Finish,” and the view has changed to view and edit the survey. A purple pop-up points to a tab at the top of the screen that reads “Actions”.",
        },
        {
          card: {
            transition: false,
            text: "Press the Add Action button",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "33.2%",
              x: "49%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image13"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The Action tab screen is open and there is a purple pop-up icon pointing to an “add action” button.",
        },
        {
          card: {
            transition: false,
            text: "Choose Event-based",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "40.7%",
              x: "49.3%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image14"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has clicked “Add Action” and a drop down with two options has appeared below the button, “Scheduled” and “Event Based”. A purple pop-up points to “Event Based”.",
        },
        {
          card: {
            transition: false,
            text: "Select the Survey response card",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "24.2%",
              x: "21.6%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image16"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "An event window pops up with 6 tiles – Survey response, Salesforce Workflow Rule, Ticket Event, JSON Event, ServiceNow, Facebook Messenger. A purple pop-up points to “Survey response”.",
        },
        {
          card: {
            transition: false,
            text: "Check the Response created box and press finish",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "47.2%",
              x: "34.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image17"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the “Response created” box has been checked and a purple pop-up points to the “Finish” button.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "58%",
              x: "62.1%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image18"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the “Response created” box has been checked and a purple pop-up points to the “Finish” button.",
        },
        {
          card: {
            transition: false,
            text: "Click the + sign under the action and select Task",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "38.2%",
              x: "6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image19"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The view has returned to the Survey “Actions” view. There’s now a tile on the screen that reads “Survey response”. A purple pop-up points to a plus sign icon on the tile.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "41.3%",
              x: "8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image20"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has clicked the plus sign icon and two options have appeared under the icon that read “Tasks” and “Conditions”. A purple pop-up points to “Task”.",
        },
        {
          card: {
            transition: false,
            text: "Select the Microsoft Teams card",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "74.3%",
              x: "22.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image21"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Tasks” and a new window appears in the middle of the screen titled “Select an app that matches what you want to do”. The window shows 12 tiles, and a purple pop-up points to the Microsoft Teams tile.",
        },
        {
          card: {
            transition: false,
            text: "Choose the Teams account",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "28.2%",
              x: "24.2%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image22"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the Microsoft Teams tile, and a new window has appeared prompting the user to choose an account. A purple pop-up points to Megan Bowen’s Teams account.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "83%",
              x: "74.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image23"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, Megan’s account has been selected and a purple pop-up points to a “Next” CTA in the lower right-hand corner of the window.",
        },
        {
          card: {
            transition: false,
            text: "Select the Team and channel to receive notifications",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "20.2%",
              x: "39.1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image24"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Next”, and a window titled “Microsoft Teams” is open. A purple pop-up points to a drop-down prompting the user to select a team.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "25%",
              x: "25.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image25"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view the user has clicked the dropdown, and a purple pop-up points to “Marketing” in the dropdown.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "75%",
              x: "26%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image26"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view the user has selected the Marketing team and is now being prompted to select a channel. A dropdown shows 9 channels- General, Public Relations, Event Planning, Design, Budgeting, Fall Social Promo, Migros, Contracts, and Marketing Leadership Team. A purple pop-up points to “Marketing Leadership Team”.",
        },
        {
          card: {
            transition: false,
            text: "Use the HTML extension to pull information from survey responses",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "50%",
              x: "73.9%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image27"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has selected the “Marketing Leadership Team” and a purple pop-up points to an HTML extension icon.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "76%",
              x: "67%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image28"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the HTML extension icon and a drop down has appeared showing 8 options – Survey Question, Embedded Data Field, GeoIP Location, DateTime, Panel Field, Quota, Response and Status. A purple pop-up points to “Response”.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "83%",
              x: "55.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image29"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Response” and a new drop-down appears to the left of “Response” showing two options—Response ID and Response Link. A purple pop-up points to “Response Link”.",
        },
        {
          card: {
            transition: false,
            text: "Include a message to guide the support team",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "55%",
              x: "25%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image27"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a text box for HTML has appeared, and a purple pop-up points to the HTML code within the text box.",
        },
        {
          card: {
            transition: false,
            text: "Press save to add the action",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "90%",
              x: "74.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image30a"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "QualtricsXM_Step1_Image27",
              "QualtricsXM_Step1_Image30a",
              "QualtricsXM_Step1_Image30b",
              "QualtricsXM_Step1_Image30c",
              "QualtricsXM_Step1_Image31",
            ],
          },
          screenReaderText:
            "In the same view, the user has typed “New customer response to NPS survey” below the HTML code in the text box. A purple pop-up points to the “Save” button in the lower right-hand corner of the window.",
        },
        {
          card: {
            transition: false,
            text: "If a customer survey response meets the established task criteria, a notification will appear in the Teams channel.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image32"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Save” and the window has disappeared. A new line has appeared on the survey tile below “Survey response” that reads “Microsoft Teams” indicating that if a user fills out the NPS survey, a notification will be sent to Microsoft Teams.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "50%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step1_Image33"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The view has changed to the Marketing Leadership Team channel in Microsoft Teams showing a notification in the chat indicating that a user has filled out the NPS survey. The notification reads, “An employee at Contoso has indicated a critical issue. They have reported the following: “customers reported getting a 15% discount code in their email, but it is not working in our POS system. Employee details: Wilber, Alex, alexw@qualtrics.com”",
        },
      ],
    },
    {
      id: 2,
      sections: [
        {
          card: {
            transition: true,
            text: "Share a survey in a Teams channel",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "50%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          card: {
            transition: false,
            text: "With Qualtrics XM for Microsoft Teams, users can distribute surveys and gather feedback to guide decision making directly in Teams.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "80%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image1"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A Teams channel titled “Design” is open. A recent post from Megan Bowen reads, “Great teamwork” and posted a dog GIF. Nestor Wilke responded to the chat, “This is awesome!” He also responded, “@Megan Bowen great job!”.",
        },
        {
          card: {
            transition: false,
            text: "Select the Qualtrics XM app from the Teams menu",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "40%",
              x: "0.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image2"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, there are 8 icons down the left side of the screen - Activity, Chat, Teams, Calendar, Calls, Files, XM Qualtrics and an ellipsis. A purple pop-up points to the “XM Qualtrics” icon.",
        },
        {
          card: {
            transition: false,
            text: "Choose the survey to share",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "38.2%",
              x: "7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image3"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the Qualtrics icon and the Qualtrics app in Teams is now open. There is a search bar and 4 options below the search bar to choose from – Customer Survey, Design Team Offsite, Employee Survey, Contoso NPS. A purple pop-up points to “Design Team Offsite”.",
        },
        {
          card: {
            transition: false,
            text: "Surveys can be created from scratch or using templates in the Qualtrics XM web app.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "83%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image4"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Design Team Offsite” and the view in the Qualtrics app has changed. It now reads “Distribute Qualtrics surveys from Teams.” The available surveys are listed on the left-hand side of the app, and Design Team offsite is highlighted.",
        },
        {
          card: {
            transition: false,
            text: "Select which team to share the survey with",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "28.3%",
              x: "18%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image5"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a drop down below a header that reads “Select your Team to distribute to”.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "31%",
              x: "18%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image6"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the drop down shows “Marketing” as the only option. A purple pop-up points to “Marketing”.",
        },
        {
          card: {
            transition: false,
            text: "Type the name of the channel",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "34.5%",
              x: "18%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image7"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a text box under a header that reads “Type the name of a channel or person.” A dropdown with a list of Teams channels is below the text box.",
        },
        {
          card: {
            transition: false,
            text: "Add individual team members",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "34.7%",
              x: "23%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image8"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, “Design” has been added to the text box. A purple pop-up points to the text box, prompting the user to type the name of any team members.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "37.3%",
              x: "22.7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image9"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, “Adele Vance” has been added to the text box.",
        },
        {
          card: {
            transition: false,
            text: "Include an optional message about the survey",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "42%",
              x: "18.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image10a"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a text box below a header that reads “Add a message (optional)”.",
        },
        {
          card: {
            transition: false,
            text: "Launch the Qualtrics web app by clicking on any of the links in the Do more with Qualtrics area",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "63%",
              x: "24%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image10a"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "QualtricsXM_Step2_Image10a",
              "QualtricsXM_Step2_Image10b",
              "QualtricsXM_Step2_Image10a",
              "QualtricsXM_Step2_Image12",
              "QualtricsXM_Step2_Image11",
            ],
          },
          screenReaderText:
            "In the same view the user types “Thanks for helping with this survey!” into the text box. A purple box outlines a series of prompts below the textbox that reads “Do more with Qualtrics”. There are 4 icon options in this box – Edit your survey, View the survey preview, View the results, Help.",
        },
        // {
        //   card: {
        //     transition: false,
        //     text: "Users can launch the Qualtrics web app by clicking on any of the links in the Do more with Qualtrics area.",
        //     snack: {
        //       isVisible: true,
        //       position: "right",
        //     },
        //     position: {
        //       y: "84%",
        //       x: "50%",
        //     },
        //     beacon: {
        //       isVisible: true,
        //       position: "right",
        //     },
        //   },
        //   images: {
        //     name: ["QualtricsXM_Step2_Image11"],
        //     imageAltText: "",
        //     sequence: false,
        //   },
        //   screenReaderText:
        //     "In the same view the user types “Thanks for helping with this survey!” into the text box. A purple box outlines a series of prompts below the textbox that reads “Do more with Qualtrics”. There are 4 icon options in this box – Edit your survey, View the survey preview, View the results, Help.",
        // },
        {
          card: {
            transition: false,
            text: "Press send to review the survey details",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "47.2%",
              x: "18.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image12"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view a purple pop-up points to a “Send” CTA below the “Add a message (optional)” text box. ",
        },
        {
          card: {
            transition: false,
            text: "Click next to preview the survey",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "62.5%",
              x: "72%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image13"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Send” and a new window titled “Review details” has appeared. The survey name, recipients and message are displayed are displayed for review. In the bottom right corner of the window, a purple pop-up points to the “next” button.",
        },
        {
          card: {
            transition: false,
            text: "Press send to share the survey with the team",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "89.8%",
              x: "84%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image14"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the next button and a new window titled “Preview Survey” is now open. In the top left corner, there are two buttons– “Restart Survey” and “Place Bookmark”. “Restart Survey” is selected. There are 2 survey questions in the middle of the window- “What works best for the offsite” with choices, “morning”, “afternoon”, “evening”. “What would you like to do” with choices, “Play mini golf”, “Visit a brewery”, “Go to a baseball game”. There is a purple pop-up in the lower right corner of the window pointing on a “send” button. ",
        },
        {
          card: {
            transition: false,
            text: "Survey distributers can open the Qualtrics web app through the confirmation card in Teams.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "84%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image15"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked send and a new window has appeared confirming that the survey was successfully sent.",
        },
        {
          card: {
            transition: false,
            text: "Return to the Teams channel to view the survey",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "17.3%",
              x: "0.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image16"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, there are 8 icons down the left side of the screen - Activity, Chat, Teams, Calendar, Calls, Files, XM Qualtrics and an ellipsis. A purple pop-up points at the “Teams” icon.",
        },
        {
          card: {
            transition: false,
            text: "Users can also share a survey in a Teams channel using the Qualtrics XM message extension.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "84%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image17"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The “Design” Teams channel is open. The “Posts” tab is showing a recent card from Qualtrics in the chat that reads - “Design Team offsite, Thanks for helping with this survey!” There is a “start” button below the message posted.",
        },
        {
          card: {
            transition: false,
            text: "Select the Qualtrics XM icon from the message toolbar",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "95.2%",
              x: "47.6%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image19"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a Qualtrics icon below the chat box in the channel.",
        },
        {
          card: {
            transition: false,
            text: "Choose a survey from the dropdown menu",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "39%",
              x: "78.8%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image20"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the Qualtrics icon in the Teams channel, and a window titled “Distribute a survey to this channel” A purple pop-up points to a drop down below a header that reads “Choose a survey.”",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "44.5%",
              x: "32.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image21"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view the user has clicked the drop down and 3 options are displayed –Customer Survey, Design Team offsite, Employee survey. A purple pop-up icon points to “Design Team offsite”.",
        },
        {
          card: {
            transition: false,
            text: "Type an optional message",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "46%",
              x: "33%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image22"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same window, a purple popup now points to a text box below a header that reads “Add a message (optional)”.",
        },
        {
          card: {
            transition: false,
            text: "Click next to review the survey details",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "71.8%",
              x: "77.6%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image23"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has typed “Thanks for helping with this survey!” into the text box. A purple pop-up now points to a “Next” button on the window.",
        },
        {
          card: {
            transition: false,
            text: "Click next again to preview the survey",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "72%",
              x: "77.6%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image24"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Next”, and a window has appeared titled “Review details.” The survey name, recipients and message are displayed are displayed for review. In the bottom right corner of the window, a purple pop-up points to the “next” button.",
        },
        {
          card: {
            transition: false,
            text: "Press send to post the survey in the channel",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "82.5%",
              x: "69.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step2_Image25"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Next” and a window titled “Preview survey” has appeared. In the top left corner, there are two buttons to select from – “Restart Survey” and “Place Bookmark”. “Restart Survey” is selected. There are 2 survey questions in the middle of the window- “What works best for the offsite” with choices, “morning”, “afternoon”, “evening”. “What would you like to do” with choices, “Play mini golf”, “Visit a brewery”, “Go to a baseball game”. There is a purple pop-up in the lower right corner of the window point at the button “send” to share the survey with the team.",
        },
      ],
    },
    {
      id: 3,
      sections: [
        {
          card: {
            transition: true,
            text: "Take a survey in a Teams channel",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "50%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          card: {
            transition: false,
            text: "The Qualtrics XM application lets users easily complete surveys without leaving Teams.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "83%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step3_Image1"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The “Design” Teams channel is open. The “Posts” tab is showing a recent card from Qualtrics - “Design Team offsite, Thanks for helping with this survey!” with a “start” CTA on the card.",
        },
        {
          card: {
            transition: false,
            text: "View the survey in the Teams channel",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "78.5%",
              x: "59.5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step3_Image2"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, there is a purple rectangle around the Qualtrics card in the Design channel thread.",
        },
        {
          card: {
            transition: false,
            text: "Click start to begin the survey",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "79.3%",
              x: "39.35%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step3_Image3"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the “Start” button on the card to begin the survey.",
        },
        {
          card: {
            transition: false,
            text: "Enter responses to the survey questions",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "29.2%",
              x: "38.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step3_Image4"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Start” and a survey window has appeared with two questions. It reads What works best for the offsite” with choices, “morning”, “afternoon”, “evening”. “What would you like to do” with choices, “Play mini golf”, “Visit a brewery”, “Go to a baseball game”. There is a purple pop-up pointing to the answer “Afternoon” for the first survey question.",
        },
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "63.7%",
              x: "38.7%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step3_Image5"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, “Afternoon” is now selected in blue and a purple pop-up points to the answer “Go to a baseball game” for the second question.",
        },
        {
          card: {
            transition: false,
            text: "Use the arrow to advance through the survey",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "77.2%",
              x: "73%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step3_Image6"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, “Afternoon” and “Go to a baseball game” are selected in blue. There is a purple pop-up pointing to the advance through the survey arrow in the bottom right corner of the window.",
        },
        {
          card: {
            transition: false,
            text: "The confirmation card lets users know their responses have been recorded.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "86%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step3_Image7"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A pop-up window is open with a thank you message for taking the survey - “We thank you for your time spent taking this survey. Your response has been recorded.”",
        },
      ],
    },
    {
      id: 4,
      sections: [
        {
          card: {
            transition: true,
            text: "Get started with Qualtrics XM in Teams",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "50%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          card: {
            transition: false,
            text: "To get the Qualtrics XM app, head to the Teams Store",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "90.5%",
              x: "0.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step4_Image1"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The “Design” Teams channel is open. There are 9 icons down the left side of the screen – Activity, Chat, Teams, Calendar, Calls, Files, Ellipses, Apps and Help. There is a purple pop-up  pointing to the “Apps” icon.",
        },
        {
          card: {
            transition: false,
            text: "Search for Qualtrics XM",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "13%",
              x: "10%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step4_Image2"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The “Apps” page is open. There is a purple pop-up pointing to a search box in the top left corner of the screen.",
        },
        {
          card: {
            transition: false,
            text: "Click the Qualtrics XM icon",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "13%",
              x: "25%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["QualtricsXM_Step4_Image2"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "QualtricsXM_Step4_Image2",
              "QualtricsXM_Step4_Image3a",
              "QualtricsXM_Step4_Image3b",
              "QualtricsXM_Step4_Image4",
            ],
          },
          screenReaderText:
            "In the same view, “Qualtrics” is entered into the search box. In the same view, 16 tiles appear in the search results. A purple pop-up points to the XM Qualtrics tile in the upper left corner.",
        },
        {
          card: {
            transition: false,
            text: "Install the app and sign in to your Qualtrics XM account",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "28%",
              x: "31.3%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["QualtricsXM_Step4_Image5"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the Qualtrics tile in the search results, and a Qualtrics pop-up is now open. A purple pop-up points to a CTA that reads “Open”.",
        },
        {
          card: {
            transition: false,
            text: "Work with your Teams administrator to pin the app to the menu bar for the entire organization.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "83%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["QualtricsXM_Step4_Image6"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked open and the Qualtrics Teams app in Microsoft Teams is now open displaying a dashboard of available surveys.",
        },
      ],
    },
    {
      id: 6,
      sections: [
        {
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["QualtricsXM_Step5_endcard"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
  ],
};
